import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  EditButton,
  DeleteWithConfirmButton,
  UrlField,
} from 'react-admin';
import filters from '../../../components/integration/webhooks/filters';
import ListActions from '../../../components/commons/listActions';
import PostPagination from '../../../components/commons/postPagination';
import PostBulkActionButtons from '../../../components/commons/postBulkActionButtons';
import FUNC from '../../../utils/functions';
import canAccess from '../../../utils/canAccess';

export default React.memo(() => {
  const { permissions } = useSelector((state: any) => state.app.appState);

  const canEdit = canAccess(permissions, FUNC.EDIT_WEBHOOK);
  const canShow = canAccess(permissions, FUNC.SHOW_WEBHOOK_DETAIL);
  const canAdd = canAccess(permissions, FUNC.ADD_WEBHOOK);
  const canDelete = canAccess(permissions, FUNC.DELETE_WEBHOOK);
  return (
    <List
      filters={filters}
      actions={<ListActions isExport isCreate={canAdd} />}
      pagination={<PostPagination />}
    >
      <Datagrid bulkActionButtons={<PostBulkActionButtons />} optimized>
        <TextField source="moduleName" />
        <TextField source="apiKeyName" />
        <TextField source="statusName" />
        <TextField source="triggerName" />
        <UrlField source="url" />
        {canShow && <ShowButton label="" />}
        {canEdit && <EditButton label="" />}
        {canDelete && <DeleteWithConfirmButton label="" mutationMode="pessimistic" />}
      </Datagrid>
    </List>
  );
});
